import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import t1 from '../../Assets/yogasana.png';
import t2 from '../../Assets/meditation.png';
import t3 from '../../Assets/pranayama.png';
import t5 from '../../Assets/surya_namaskar.png';
import FacultyCard from './FacultyCard';
import styles from './FacultyCard.module.css';

const Faculty = () => {
    const [state] = useState([
        {
            img: t1,
            title: "Yogasana",
            text: "Increased flexibility.Increased muscle strength.Improved respiration, energy.Weight reduction.Maintaining a balanced metabolism.",
            id: 1,
            size: "large" // Spans two columns/rows in the grid
        },
        {
            img: t2,
            title: "Meditation",
            text: "Reduces Stress.Controls Anxiety.Promotes Emotional Health.Enhances Self-Awareness.",
            id: 2,
            size: "small"
        },
        {
            img: t3,
            title: "Pranayama",
            text: "Helps to prevent stress.Levels up your energy.Balances your heart rate.",
            id: 3,
            size: "small"
        },
        {
            img: t5,
            title: "Surya Namaskar",
            text: "Helps lose weight.Glowing skin.Better digestive system.Ensures regular menstrual cycle.",
            id: 4,
            size: "medium" // Spans two columns horizontally
        }
    ]);

    const { ref, inView } = useInView({
        threshold: 0.1,
        triggerOnce: true
    });

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.15
            }
        }
    };

    const itemVariants = {
        hidden: { y: 40, opacity: 0 },
        visible: {
            y: 0,
            opacity: 1,
            transition: { type: "spring", stiffness: 100, damping: 12 }
        }
    };

    return (
        <section className={styles.facultySection} id="GoToFaculty">
            <div className={styles.sectionHeader}>
                <h2 className={styles.title}>Our Programs</h2>
                <p className={styles.subtitle}>Discover the perfect balance tailored for your wellness goals.</p>
            </div>

            <motion.div
                ref={ref}
                className={styles.bentoGrid}
                variants={containerVariants}
                initial="hidden"
                animate={inView ? "visible" : "hidden"}
            >
                {state.map((item) => (
                    <motion.div
                        key={item.id}
                        variants={itemVariants}
                        className={`${styles.bentoItem} ${styles[item.size]}`}
                    >
                        <FacultyCard
                            title={item.title}
                            text={item.text}
                            img={item.img}
                        />
                    </motion.div>
                ))}
            </motion.div>
        </section>
    );
}

export default Faculty;
